import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
	changeDetection: ChangeDetectionStrategy.OnPush,
	selector: 'bp-icon-help',
	templateUrl: './icon-help.component.svg',
})
export class IconHelpComponent {}
